import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { scrollToPurchase } from '../utils/scrollToPurchase';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (approx 600px)
      // Hide when reaching the bottom near the purchase section
      const scrollY = window.scrollY;
      const purchaseSection = document.getElementById('compra');
      if (!purchaseSection) return;
      const purchaseTop = purchaseSection.offsetTop;
      const windowHeight = window.innerHeight;
      // Show if scrolled past 600px AND haven't reached the purchase section yet
      if (scrollY > 600 && scrollY + windowHeight < purchaseTop + 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-81">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} className="fixed bottom-0 left-0 right-0 z-40 p-4 bg-gradient-to-t from-zinc-950 via-zinc-950/90 to-transparent pointer-events-none" data-id="element-82">
          <div className="max-w-md mx-auto pointer-events-auto" data-id="element-83">
            <Button fullWidth size="md" onClick={scrollToPurchase} className="shadow-2xl shadow-amber-500/20 py-4" data-id="element-84">
              QUIERO ORDENAR MI SEMANA
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}